import * as React from "react";
const IconBook = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.2363 6.0458V20.2949M5.23633 8.24707C6.5021 8.4431 7.91411 8.769 9.23633 9.28031M5.23633 12.2471C5.87582 12.3461 6.55263 12.4783 7.23633 12.6508M4.23066 3.0037C6.44903 3.25438 9.42946 3.92875 11.5532 5.41688C11.9613 5.70288 12.5113 5.70288 12.9195 5.41688C15.0432 3.92875 18.0236 3.25438 20.242 3.0037C21.3399 2.87964 22.2363 3.79646 22.2363 4.92761V16.1924C22.2363 17.3235 21.3399 18.2407 20.242 18.3648C18.0236 18.6154 15.0432 19.2898 12.9195 20.7779C12.5113 21.0639 11.9613 21.0639 11.5532 20.7779C9.42946 19.2898 6.44903 18.6154 4.23066 18.3648C3.13275 18.2407 2.23633 17.3235 2.23633 16.1924V4.92761C2.23633 3.79646 3.13275 2.87964 4.23066 3.0037Z"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
export default IconBook;
